export default __webpack_public_path__ + "static/YasnoClown-5fb17241f954bb306f5f1e6be6e22e83.png";